import { faFileAlt } from '@fortawesome/pro-regular-svg-icons';
import { faCommentSmile, faEnvelope, faImages, faPlusCircle, faThumbsUp } from '@fortawesome/pro-solid-svg-icons';
import { Location } from 'history';
import isNumber from 'lodash-es/isNumber';
import {
    ADD_ALBUM_OR_ARTICLE,
    ADD_POST,
    CREATE_ALBUM,
    DRAFTS,
    PROFILE_OF_USER,
    USER_LIKE,
    USER_UNLIKE,
    WRITE_ARTICLE,
    WRITE_SHORT_MESSAGE,
} from 'mk/autogenerated/translations/ProfileDetailPage.eca1d056276a7ee066090090dd42d6c5'
import { isAuthenticated, isAuthenticatedAs } from 'mk/bazaar/common/userUtils';
import { BlogPostFormData } from 'mk2/apps/blogs/components/BlogPostCreateForm';
import { AvatarGridType } from 'mk2/apps/blogs/components/MoreAboutMe';
import ProfileSideMenu from 'mk2/apps/blogs/components/ProfileSideMenu';
import {
    blogsDeletePostTrigger,
    blogsIgnoreUserTrigger,
    blogsSetDisplayingAtFeedTrigger,
    blogsSetPostVisibilityTrigger,
} from 'mk2/apps/blogs/containers/BlogsShared/BlogsShared.actions';
import blogsSharedReducer from 'mk2/apps/blogs/containers/BlogsShared/BlogsShared.reducers';
import blogsSharedSaga from 'mk2/apps/blogs/containers/BlogsShared/BlogsShared.sagas';
import commentsSaga from 'mk2/apps/blogs/containers/Comments/Comments.sagas';
import {
    PROFILE_CREATE_POST_SELECT_TYPE_MENU,
    PROFILE_FEED_MENU_POST_TYPE_FILTER,
} from 'mk2/apps/blogs/containers/ProfileDetail/ProfileDetail.constants';
import {
    initialProfileFeedPageState,
    ProfileDetailsState,
    ProfileDetailData,
    ProfileFeedPageState,
    ProfileFeedVirtualPageState,
} from 'mk2/apps/blogs/containers/ProfileDetail/ProfileDetail.reducers';
import {
    getProfileDetailsState,
    getProfileDetailSearchState,
} from 'mk2/apps/blogs/containers/ProfileDetail/ProfileDetail.selectors';
import {
    userStrollersConnectionCreateTrigger,
    userStrollersConnectionRemoveTrigger,
    userStrollersReloadSuggestionsTrigger,
} from 'mk2/apps/blogs/containers/UserStrollersWidget/UserStrollersWidget.actions';
import { SuggestedStrollerOption } from 'mk2/apps/blogs/containers/UserStrollersWidget/UserStrollersWidget.interfaces';
import sagaUserStrollers from 'mk2/apps/blogs/containers/UserStrollersWidget/UserStrollersWidget.sagas';
import { BLOG_POST_MENU_MORE, BLOG_POST_VISIBILITY_MENU_MORE } from 'mk2/apps/blogs/helpers';
import {
    BlogPostEntity,
    BlogPostSchema,
    BlogPostType,
    GroupEntity,
    GroupSchema,
    PostVisibility,
} from 'mk2/apps/blogs/schemas';
import {
    blogsAlbumCreateUrl,
    blogsArticleCreateUrl,
    blogsArticleDraftsUrl,
    blogsProfileMoreAboutUrlNew,
    blogsProfileUrlNew,
    blogsShortMessageCreateUrl,
} from 'mk2/apps/blogs/urls';
import { PageRef } from 'mk2/apps/forum/schemas';
import { parsePageNumber } from 'mk2/apps/forum/utils';
import { emptyComplaintsCounts } from 'mk2/apps/groups/containers/GroupReportedFeed/GroupReportedFeed.constants';
import {
    getCommentComplaintsCounts,
    getPostsCommentsCount,
} from 'mk2/apps/groups/containers/GroupShared/GroupShared.selectors';
import { mailComposeUrl } from 'mk2/apps/mail/urls';
import { KidEntity, KidSchema } from 'mk2/apps/settings/schemas';
import {
    StrollerEntity,
    StrollerSchema,
    StrollerUserReviewEntity,
    StrollerUserReviewSchema,
} from 'mk2/apps/strollers/schemas';
import MenuItem from 'mk2/components/menu/MenuItem';
import Btn, { BtnLayout, BtnType } from 'mk2/components/Btn';
import { AppName } from 'mk2/containers/Application/Application';
import { abFetch } from 'mk2/containers/AB/AB.actions';
import { ABState } from 'mk2/containers/AB/AB.reducers';
import { getABVariant } from 'mk2/containers/AB/AB.selectors';
import { complaintOpenTrigger } from 'mk2/containers/Complaint/Complaint.actions';
import { ComplaintTargetType } from 'mk2/containers/Complaint/Complaint.schemas';
import { getComplaintsShownForBlogPosts } from 'mk2/containers/Complaints/Complaints.selectors';
import Menu from 'mk2/containers/Menu/Menu';
import { menuToggle } from 'mk2/containers/Menu/Menu.actions';
import { cacheLast, memoizeOne } from 'mk2/helpers/cache';
import { UserAgentParsed } from 'mk2/helpers/detects';
import { MapDispatchToPropsObject } from 'mk2/helpers/types';
import { url } from 'mk2/helpers/urls';
import Page, { BrandingProps, PageLayout, RightContentSide } from 'mk2/pages/Page';
import {
    getRequestDeviceIsIOS,
    getRequestDeviceMobile,
    getRequestPermissions,
    getRequestUser,
    getRequestUserAgent,
    AppState,
} from 'mk2/reducers';
import { isFailure, isSuccess, LoadingState } from 'mk2/reducers/loadingState';
import {
    MenuSelection,
    PhotoEntity,
    PhotoSchema,
    ProVendorEntity,
    ProVendorSchema,
    UserEntity,
    UserSchema,
} from 'mk2/schemas';
import { getDenormalizedEntities, getDenormalizedEntity } from 'mk2/selectors';
import { Store } from 'mk2/store/configureStore';
import { parse } from 'query-string';
import React from 'react';
import { MapStateToPropsParam } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import ProfileDetail, { BLOG_POST_CREATE_FORM_NAME } from './ProfileDetail';
import {
    blogPostCreateTrigger,
    profileDeleteAvatarByAdminTrigger,
    profileDetailFetchTrigger,
    profileExpandAvatarGridTrigger,
    profileExpandGroupListTrigger,
    profileFeedFetchTrigger,
    profileFeedScrollToTrigger,
    profileSetLikeUserTrigger,
} from './ProfileDetail.actions';
import reducer, { ProfileDetailState } from './ProfileDetail.reducers';
import saga from './ProfileDetail.sagas';
import {
    getProfileDetailState,
    getProfileFeedPageState,
    getProfileFeedVirtualPageState,
} from './ProfileDetail.selectors';

export enum ScrollToPosition {
    FirstPost = 'first',
    LastPost = 'last',
}

interface OwnProps {}

interface StateProps {
    anyPageLoaded: boolean;
    commentsCounts: { [postId: number]: number };
    complaintsCounts: { [feedItemId: number]: number };
    complaintsOpened: boolean[];
    creatingPostABState: ABState;
    detailErrorMessage: string;
    detailLoadingState: LoadingState;
    feedErrorMessage: string;
    feedLoadingState: LoadingState;
    initialValues: BlogPostFormData;
    isIOS: boolean;
    isMobile: boolean;
    loadedAt: number;
    numberOfPages: number;
    pageRef: PageRef;
    posts: BlogPostEntity[];
    postType: BlogPostType;
    profileDetailData: ProfileDetailData;
    query: string;
    redirectToPost: number;
    requestUser: UserEntity;
    requestUserPermissions: string[];
    showMoreAboutMe: boolean;
    suggestedStrollerOptions: SuggestedStrollerOption[];
    userAgent: UserAgentParsed;
}

interface DispatchProps {
    onAddMyStroller(strollerId: number, username: string);
    onAddPost(username: string, values: BlogPostFormData);
    onDelete(postId: number);
    onDeleteAvatarByAdmin(username: string);
    onExpandAvatarGrid(avatarGridType: AvatarGridType, username: string);
    onExpandGroupList(username: string);
    onIgnoreUser(username: string);
    onLoadCreatingPostVariant();
    onLoadProfileDetail(username: string);
    onLoadProfileFeed(username: string, pageRef: PageRef, postType: BlogPostType, query: string, currentUrl: Location, numPostsBeforeLoad: number);
    onPostToggleMenuMore(postId: number);
    onPostToggleVisibilityMenuMore(postId: number);
    onPostTypeFilterMenuMore();
    onReloadStrollerSuggestions(searchTerm: string);
    onRemoveMyStroller(strollerId: number, username: string);
    onReport(entity: ComplaintTargetType, id: number);
    onScrollTo(scrollto: ScrollToPosition);
    onSetDisplayingAtFeed(postId: number, displaying: boolean);
    onSetLikeUser(username: string, like: boolean);
    onSetVisibility(postId: number, visibility: PostVisibility);
    onShowAddPostTypeMenu();
}

type RouteProps = RouteComponentProps<{
    username: string;
}>;

interface Query {
    postid: string;
    postType: BlogPostType;
    query: string;
}

const emptyArray = [];

export type Props = OwnProps & StateProps & DispatchProps & RouteProps;

export default class ProfileDetailPage extends Page<OwnProps & RouteProps, StateProps, DispatchProps> {

    private parseQuery = memoizeOne((qs: string): Query => {
        const qp = parse(qs) || {};
        let postType; // keep undefined if not in url, set null if incorrect
        if (qp['post-type'] !== undefined || qp.post_type !== undefined) {
            const postTypeStr = qp['post-type'] as string || qp.post_type as string;
            postType = {
                [BlogPostType.ALBUM.toString()]: BlogPostType.ALBUM,
                [BlogPostType.SHORT_MESSAGE.toString()]: BlogPostType.SHORT_MESSAGE,
                [BlogPostType.ARTICLE.toString()]: BlogPostType.ARTICLE,
                [BlogPostType.AUTOMATIC_MESSAGE.toString()]: BlogPostType.AUTOMATIC_MESSAGE,
                [BlogPostType.SHARE.toString()]: BlogPostType.SHARE,
            }[postTypeStr] || null;
        }
        return {
            postType,
            query: qp.query !== undefined ? qp.query as string : null,
            postid: qp.postid !== undefined ? qp.postid as string : null,
        };
    });

    private handleLikeUserCache = cacheLast();
    private handleUnlikeUserCache = cacheLast();
    private initialValuesCache = cacheLast();
    private profileDetailDataCache = cacheLast();

    public mapStateToProps(): MapStateToPropsParam<StateProps, OwnProps & RouteProps, AppState> {
        return (state: AppState, ownProps: OwnProps & RouteProps): StateProps => {
            const parsedQuery: Query = this.parseQuery(ownProps.location.search);
            const query = parsedQuery.query;
            const postType = parsedQuery.postType;
            const redirectToPost = parseInt(parsedQuery.postid, 10);
            const pageRef = parsePageNumber(ownProps.location);

            const username = ownProps.match.params.username;
            const profileState: ProfileDetailState = getProfileDetailState(state, username);

            const showMoreAboutMe = ownProps.location.pathname === url(blogsProfileMoreAboutUrlNew, {username});

            const profileDetailData = profileState.profileDetailData;

            const user: UserEntity = getDenormalizedEntity<UserEntity>(state, UserSchema, profileDetailData.user);

            const userVendorData: ProVendorEntity = profileDetailData.userVendorData
                ? getDenormalizedEntity<ProVendorEntity>(state, ProVendorSchema, profileDetailData.userVendorData)
                : null;

            const requestUserPermissions = getRequestPermissions(state);
            const requestUser = getRequestUser(state);
            const userAgent = getRequestUserAgent(state);

            const isAdmin = requestUserPermissions.indexOf('photoblog.can_manage_blogs') >= 0;

            const profileDetailsState: ProfileDetailsState = getProfileDetailsState(state);

            const profileDetailDataDenormalized = {
                ambassadorBrandGroupId: profileDetailData.ambassadorBrandGroupId,
                ambassadorBrandLogo: getDenormalizedEntity<PhotoEntity>(state, PhotoSchema, profileDetailData.ambassadorBrandLogo),
                ambassadorBrandName: profileDetailData.ambassadorBrandName,
                displayVisibilityAlert: profileDetailData.displayVisibilityAlert,
                followers: {
                    count: profileDetailData.followers.count,
                    expanded: profileDetailData.followers.expanded,
                    hasMore: profileDetailData.followers.hasMore,
                    users: getDenormalizedEntities<UserEntity>(state, UserSchema, profileDetailData.followers.users),
                },
                following: {
                    count: profileDetailData.following.count,
                    expanded: profileDetailData.following.expanded,
                    hasMore: profileDetailData.following.hasMore,
                    users: getDenormalizedEntities<UserEntity>(state, UserSchema, profileDetailData.following.users),
                },
                isLegacyBlocked: profileDetailData.isLegacyBlocked,
                kids: getDenormalizedEntities<KidEntity>(state, KidSchema, profileDetailData.kids),
                memberOfGroups: {
                    count: profileDetailData.memberOfGroups.count,
                    hasMore: profileDetailData.memberOfGroups.hasMore,
                    groups: getDenormalizedEntities<GroupEntity>(state, GroupSchema, profileDetailData.memberOfGroups.groups),
                },
                pregnancyDaysCounter: profileDetailData.pregnancyDaysCounter,
                pregnancyWeekNumber: profileDetailData.pregnancyWeekNumber,
                user,
                userAboutMeText: profileDetailData.userAboutMeText,
                userAge: profileDetailData.userAge,
                userAvatarPhoto: getDenormalizedEntity<PhotoEntity>(state, PhotoSchema, profileDetailData.userAvatarPhoto),
                userIsInactive: profileDetailData.userIsInactive,
                userIsLiked: profileDetailData.userIsLiked,
                userOnlineStatus: profileDetailData.userOnlineStatus,
                userRegisteredOn: profileDetailData.userRegisteredOn,
                userResidence: profileDetailData.userResidence,
                userResidenceCountyId: profileDetailData.userResidenceCountyId,
                userStats: profileDetailData.userStats,
                userStrollers: getDenormalizedEntities<StrollerEntity>(state, StrollerSchema, profileDetailData.userStrollers),
                userStrollersReviews: getDenormalizedEntities<StrollerUserReviewEntity>(state, StrollerUserReviewSchema, profileDetailData.userStrollersReviews),
                userVendorData,
            };

            const profileDetailSearchState = getProfileDetailSearchState(state, username, postType, query);
            const anyPageLoaded = Object.keys(profileDetailSearchState.pages).some((page) => isSuccess(profileDetailSearchState.pages[page].loadingState));

            const profileFeedPageState: ProfileFeedPageState | ProfileFeedVirtualPageState = isNumber(pageRef)
                ? getProfileFeedPageState(state, username, postType, query, pageRef)
                : getProfileFeedVirtualPageState(state, username, postType, query, pageRef);

            const postIds = isNumber(pageRef)
                ? (profileFeedPageState as ProfileFeedPageState).postIds
                : initialProfileFeedPageState.postIds;

            const loadedAt = (profileFeedPageState as ProfileFeedPageState).loadedAt;

            const numberOfPages = profileDetailSearchState.numberOfPages;

            const posts: BlogPostEntity[] = getDenormalizedEntities<BlogPostEntity>(state, BlogPostSchema, postIds);

            const commentsLoadingState = profileDetailsState.commentsLoadingState;

            const commentsCounts = getPostsCommentsCount(state, posts);

            const complaintsCounts = isAdmin
                ? getCommentComplaintsCounts(state, postIds, commentsLoadingState)
                : emptyComplaintsCounts;

            const creatingPostABState = getABVariant(state, 'profile_creating_post_ui');

            return {
                anyPageLoaded,
                commentsCounts,
                complaintsCounts,
                complaintsOpened: getComplaintsShownForBlogPosts(state, posts),
                creatingPostABState,
                detailErrorMessage: profileState.detailErrorMessage,
                detailLoadingState: profileState.detailLoadingState,
                feedErrorMessage: profileState.feedErrorMessage,
                feedLoadingState: profileState.feedLoadingState,
                initialValues: this.initialValuesCache(
                    {
                        perex: '',
                        photos: emptyArray,
                        sticker: null,
                        publicVisibility: profileDetailData.defaultPostVisibility !== null && profileDetailData.defaultPostVisibility === PostVisibility.Public,
                    },
                    BLOG_POST_CREATE_FORM_NAME,
                    profileDetailData.defaultPostVisibility,
                ),
                isIOS: getRequestDeviceIsIOS(state),
                isMobile: getRequestDeviceMobile(state),
                loadedAt,
                numberOfPages,
                pageRef: parsePageNumber(ownProps.location),
                posts,
                postType,
                profileDetailData: this.profileDetailDataCache(profileDetailDataDenormalized, ...Object.values(profileDetailData)),
                query,
                redirectToPost,
                requestUser,
                requestUserPermissions,
                showMoreAboutMe,
                suggestedStrollerOptions: profileDetailsState.suggestedStrollerOptions,
                userAgent,
            };
        };
    }

    public mapDispatchToProps(): MapDispatchToPropsObject<DispatchProps> {
        return {
            onAddMyStroller: userStrollersConnectionCreateTrigger,
            onAddPost: blogPostCreateTrigger,
            onDelete: blogsDeletePostTrigger,
            onDeleteAvatarByAdmin: profileDeleteAvatarByAdminTrigger,
            onExpandAvatarGrid: profileExpandAvatarGridTrigger,
            onExpandGroupList: profileExpandGroupListTrigger,
            onIgnoreUser: blogsIgnoreUserTrigger,
            onLoadCreatingPostVariant: () => abFetch('profile_creating_post_ui'),
            onLoadProfileDetail: profileDetailFetchTrigger,
            onLoadProfileFeed: profileFeedFetchTrigger,
            onPostToggleMenuMore: (postId: number) => menuToggle(BLOG_POST_MENU_MORE(postId)),
            onPostToggleVisibilityMenuMore: (postId: number) => menuToggle(BLOG_POST_VISIBILITY_MENU_MORE(postId)),
            onPostTypeFilterMenuMore: () => menuToggle(PROFILE_FEED_MENU_POST_TYPE_FILTER),
            onReloadStrollerSuggestions: userStrollersReloadSuggestionsTrigger,
            onRemoveMyStroller: userStrollersConnectionRemoveTrigger,
            onReport: complaintOpenTrigger,
            onScrollTo: profileFeedScrollToTrigger,
            onSetDisplayingAtFeed: blogsSetDisplayingAtFeedTrigger,
            onSetLikeUser: profileSetLikeUserTrigger,
            onSetVisibility: blogsSetPostVisibilityTrigger,
            onShowAddPostTypeMenu: () => menuToggle(PROFILE_CREATE_POST_SELECT_TYPE_MENU),

        };
    }

    public getMetaTitle(props: Props): string {
        const {match: { params: { username } }} = props;
        return `${PROFILE_OF_USER} ${username}`;
    }

    public render(props: Props): false | JSX.Element {
        return (
            <ProfileDetail {...props} />
        );
    }

    public renderRight(props: Props): JSX.Element {

        const {
            detailLoadingState, isMobile, location, match: { params: { username } }, profileDetailData, redirectToPost,
            requestUser, requestUserPermissions, suggestedStrollerOptions, onAddMyStroller, onDeleteAvatarByAdmin,
            onExpandAvatarGrid, onExpandGroupList, onLoadProfileDetail, onReloadStrollerSuggestions, onRemoveMyStroller,
            onSetLikeUser,
        } = props;

        return (
            isMobile ||
            profileDetailData.user && (profileDetailData.user.isBlocked) ||
            isFailure(detailLoadingState) ||
            redirectToPost
        ) ? null : (
            <ProfileSideMenu
                isMobile={isMobile}
                location={location}
                loadingState={detailLoadingState}
                onAddMyStroller={onAddMyStroller}
                onDeleteAvatarByAdmin={onDeleteAvatarByAdmin}
                onExpandAvatarGrid={onExpandAvatarGrid}
                onExpandGroupList={onExpandGroupList}
                onLoadProfileDetail={onLoadProfileDetail}
                onReloadStrollerSuggestions={onReloadStrollerSuggestions}
                onRemoveMyStroller={onRemoveMyStroller}
                onSetLikeUser={onSetLikeUser}
                profileDetailData={profileDetailData}
                requestUser={requestUser}
                requestUserPermissions={requestUserPermissions}
                suggestedStrollerOptions={suggestedStrollerOptions}
                username={username}
            />
        );
    }

    public getPageLayout(app: AppName, props: Props): PageLayout {
        const { detailLoadingState, profileDetailData } = props;
        return (profileDetailData.user && profileDetailData.user.isBlocked || isFailure(detailLoadingState))
            ? PageLayout.MainContent
            : PageLayout.MainContentWithRightColumn;
    }

    public getRightContentSide(app: AppName, props: Props): RightContentSide {
        return RightContentSide.LeftSide;
    }

    public hasHeaderBackButton(props: Props): boolean {
        return props.showMoreAboutMe;
    }

    public getDefaultBackPath(props: Props): string {
        const {showMoreAboutMe, match: {params: { username }} } = props;
        return showMoreAboutMe ? url(blogsProfileUrlNew, {username}) : null;
    }

    public getHeaderTitle(props: Props): string {
        const {isMobile, profileDetailData, showMoreAboutMe} = props;
        if (isMobile && showMoreAboutMe && !!profileDetailData) {
            return profileDetailData.user.username;
        }
    }

    public getHeaderRight(props: Props): React.ReactElement {
        const {
            creatingPostABState, isMobile, match: { params: { username } }, onSetLikeUser, onShowAddPostTypeMenu,
            profileDetailData: { user, userIsLiked, userStats: { blogsArticleDraftsCount} }, requestUser, showMoreAboutMe,
        } = props;

        if (!user || !isAuthenticated(requestUser) || !isMobile || (isMobile && showMoreAboutMe)) {
            return null;
        }

        const isOwner = isAuthenticatedAs(requestUser, user);

        return (
            <>
                {isOwner ? (
                    <Menu
                        menuId={PROFILE_CREATE_POST_SELECT_TYPE_MENU}
                        trigger={(
                            <Btn
                                layout={BtnLayout.IconLabelCount}
                                type={BtnType.Blue}
                                icon={faPlusCircle}
                                hasSpinner={!isSuccess(creatingPostABState.loadingState)}
                                disabled={!isSuccess(creatingPostABState.loadingState)}
                                label={creatingPostABState.variant === 'menu' ? ADD_POST : ADD_ALBUM_OR_ARTICLE}
                                onClick={onShowAddPostTypeMenu}
                            />
                        )}
                        triggerShadow={false}
                    >
                        {creatingPostABState.variant === 'menu' && (
                            <MenuItem
                                icon={faCommentSmile}
                                label={WRITE_SHORT_MESSAGE}
                                link={url(blogsShortMessageCreateUrl, {username})}
                            />
                        )}
                        <MenuItem
                            icon={faImages}
                            label={CREATE_ALBUM}
                            link={url(blogsAlbumCreateUrl, {username})}
                        />
                        <MenuItem
                            icon={faFileAlt}
                            label={blogsArticleDraftsCount ? DRAFTS : WRITE_ARTICLE}
                            link={
                                blogsArticleDraftsCount
                                    ? url(blogsArticleDraftsUrl, {username})
                                    : url(blogsArticleCreateUrl, {username})
                            }
                        />
                    </Menu>
                ) : (
                    <>
                        <Btn
                            layout={BtnLayout.IconLabelCount}
                            type={BtnType.BlueOutline}
                            icon={faEnvelope}
                            link={url(mailComposeUrl, {}, { to: user.username })}
                        />
                        {!isOwner && (
                            <>
                                &nbsp;
                                {!userIsLiked ? (
                                    <Btn
                                        layout={BtnLayout.IconLabelCount}
                                        type={BtnType.Blue}
                                        icon={faThumbsUp}
                                        label={<b>{USER_LIKE}</b>}
                                        onClick={this.handleLikeUserCache(() => onSetLikeUser(user.username, true))}
                                    />
                                ) : (
                                    <Btn
                                        layout={BtnLayout.IconLabelCount}
                                        type={BtnType.BlueOutline}
                                        label={<b>{USER_UNLIKE}</b>}
                                        onClick={this.handleUnlikeUserCache(() => onSetLikeUser(user.username, false))}
                                    />
                                )}
                            </>
                        )}
                    </>
                )}
            </>
        );
    }

    public getHeaderMenuSelection(app: AppName, props: Props): MenuSelection {
        return {
            activeSection: 'photoblog',
            activeItem: null,
        };
    }

    public getBrandingProps(props: Props): BrandingProps {
        return {
            zone: 'Blogs - Branding',
        };
    }

    public registerInStore(store: Store<AppState>) {
        store.injectReducer('containers.blogs.profileDetails', reducer);
        store.injectSaga('containers.blogs.profileDetails', saga);

        store.injectReducer('containers.blogs.blogsShared', blogsSharedReducer);
        store.injectSaga('containers.blogs.blogsShared', blogsSharedSaga);

        store.injectSaga('containers.blogs.shared.comments', commentsSaga);

        store.injectSaga('containers.blogs.shared.userStrollers', sagaUserStrollers);
    }

    public getCanonicalUrl(baseUrl: string, props: Props): string {
        const { pageRef, numberOfPages, match: { params: { username }} } = props;

        const hasPageNums: boolean = numberOfPages !== null && pageRef !== null && isNumber(pageRef);
        if (hasPageNums) {
            return baseUrl + url(blogsProfileUrlNew, { username }, { page: pageRef });
        }
    }

}
